import React, { useState } from 'react';
import UploadButton from './UploadButton';
import UploadList from './UploadList';
const Upload = (props) => {
    const { accept, disabled, multiple } = props;
    const [fileList, setFileList] = useState([]);
    const uploadProps = {
        accept,
        disabled,
        multiple,
    };
    return (React.createElement("span", null,
        React.createElement(UploadButton, { ...uploadProps, setFileList: setFileList }),
        React.createElement(UploadList, { items: fileList })));
};
if (process.env.NODE_ENV !== 'production') {
    Upload.displayName = 'Upload';
}
export default Upload;
//# sourceMappingURL=index.js.map